var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSuccessfully(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30 56.875C15.175 56.875 3.125 44.825 3.125 30C3.125 15.175 15.175 3.125 30 3.125C44.825 3.125 56.875 15.175 56.875 30C56.875 44.825 44.825 56.875 30 56.875ZM30 6.875C17.25 6.875 6.875 17.25 6.875 30C6.875 42.75 17.25 53.125 30 53.125C42.75 53.125 53.125 42.75 53.125 30C53.125 17.25 42.75 6.875 30 6.875Z",
    fill: "#01C860"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.4511 38.9499C25.9511 38.9499 25.4761 38.7499 25.1261 38.3999L18.0511 31.3249C17.3261 30.5999 17.3261 29.3999 18.0511 28.6749C18.7761 27.9499 19.9761 27.9499 20.7011 28.6749L26.4511 34.4249L39.3011 21.5749C40.0261 20.8499 41.2261 20.8499 41.9511 21.5749C42.6761 22.2999 42.6761 23.4999 41.9511 24.2249L27.7761 38.3999C27.4261 38.7499 26.9511 38.9499 26.4511 38.9499Z",
    fill: "#01C860"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessfully);
export default __webpack_public_path__ + "static/media/successfully.34d47b03106f248bdaee394dfc41a428.svg";
export { ForwardRef as ReactComponent };